const garageChoicesMobile = document.querySelector('.garage_choice_mobile')
if (garageChoicesMobile) {
  const selectGarageMobile = document.querySelector('.menu_telephone_mobile')
  if (selectGarageMobile) {
    selectGarageMobile.addEventListener('click', e => {
      e.preventDefault()
      e.stopPropagation()
      garageChoicesMobile.classList.add('show')
    })
  }

  document.querySelector('body').addEventListener('click', () => {
    garageChoicesMobile.classList.remove('show')
  })
}



// WEBPACK FOOTER //
// ./scripts/select_garage_mobile.js